import { Link } from 'react-router-dom';
import { popularComics } from '@/mocks/comics';

export default function PopularRanking() {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            <i className="ri-fire-line mr-1"></i>热门推荐
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            人气排行榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            百万读者力荐，不容错过的经典之作
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {popularComics.slice(0, 3).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-50 cursor-pointer flex flex-col md:flex-row"
            >
              <div className="md:w-2/5 relative overflow-hidden">
                <div className="aspect-[3/4] md:aspect-auto md:h-full relative">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫画免费阅读`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-sm font-bold">
                  {index + 1}
                </div>
              </div>

              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-primary-100 text-primary-700">
                    {comic.categoryName}
                  </span>
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${
                    comic.status === '连载中'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-foreground-200 text-foreground-700'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 mb-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {comic.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {comic.rating.toFixed(1)}
                  </span>
                  <span>{comic.chapters}话</span>
                  <span>{formatViews(comic.views)}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 mt-4">
          {popularComics.slice(3).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group bg-background-50 rounded-xl p-3 md:p-4 flex items-center gap-3 cursor-pointer hover:bg-background-50/80 transition-colors"
            >
              <span className="text-sm font-bold text-foreground-300 w-5 text-center">
                {index + 4}
              </span>
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </p>
                <p className="text-xs text-foreground-400">{comic.categoryName}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}